<div class="gray-bg-rounded mt-3">
  <div class="col-md-6" *ngIf="false">
    <label for="file-upload" class="btn-choice">
      <span class="d-block">Docusign Link Attached in Email:</span>
      <input
        jniAutoCompleteBlocker
        type="checkbox"
        id="docusignCheck"
        class="ms-3"
        [(ngModel)]="isDocusignLinkAttach"
        (click)="onValueCheck()" />
      <!-- <div class="input-field mt-4">
      <button type="button">Select</button>
    </div> -->
    </label>
  </div>

  <div class="col-auto py-1 attachment-box">
    <div class="box-card input-files mt-4 p-3">
      <div class="d-flex justify-content-between mb-6" *ngIf="fileName">
        <div>
          <a style="cursor: pointer">
            <span data-toggle="tooltip" title="pdf">
              {{ fileName }}
            </span>
          </a>
          <span></span>
        </div>
        <span> </span>
      </div>
      <div
        class="d-flex justify-content-between mb-6 col-6 globalborder-btm-header align-items-center"
        *ngFor="let file of filesObject; let in = index">
        <div>
          <a
            class="has-link"
            style="cursor: pointer"
            (click)="onViewAttachment(file)">
            <span data-toggle="tooltip" title="{{ file.fileName }}">
              {{ file.fileName }}
            </span>
          </a>
          <a>{{ file.fileSizeName }}</a>
        </div>
        <span>
          <p-button
            (onClick)="fileRemove(file)"
            icon="pi pi-times"
            [text]="true"
            [rounded]="true" />
        </span>
      </div>
    </div>
  </div>
</div>
